import { useDetails } from "./Details.hooks"
import { Container } from "./Details.styles";
import { Basic } from "./Tabs/Basic";
import { Participations } from "./Tabs/Participations";
import { ParticipationsDetail } from "./Tabs/ParticipationsDetail";
import { Reviews } from "./Tabs/Reviews";

export const Details = () => {
  const { activeTab, data, isDataLoading } = useDetails();
  if (!data && !isDataLoading) return null;
  return (
    <Container>
      {activeTab === 0 &&
        <Basic />
      }
      {activeTab === 1 &&
        <Participations />
      }
      {activeTab === 2 &&
        <Reviews />
      }
      {activeTab === 3 &&
        <ParticipationsDetail />
      }
    </Container>
  )
}
